/* eslint-disable no-unused-vars */
export const urls = {
    getL2PTracker: (leadId, bookingId) => `/api/inspection/tracker?leadId=${leadId}&bookingId=${bookingId}`,
    priceSubmit: () => '/api/inspection/user/preference'
};

export const initialState = {
    isFetching: false,
    error: {},
    l2pData: {},
    l2pAppRedirection: false
};

const l2p = (state = initialState, action) => {
    switch (action.type) {
        case 'FETCHING': {
            return {
                ...state,
                isFetching: action.isFetching
            };
        }
        case 'RECEIVE_L2P': {
            return {
                ...state,
                l2pData: action.data,
                error: {}
            };
        }
        case 'ERROR': {
            return {
                ...state,
                error: action.error
            };
        }
        case 'SET_L2P_APP_REDIRECTION': {
            return {
                ...state,
                l2pAppRedirection: action.l2pAppRedirection
            };
        }
        default:
            return state;
    }
};

export default l2p;
